import { getReporters } from './reporters.js';
export function alias(id) {
    // Call the alias method on reporters
    const reporters = getReporters();
    for (const reporter of reporters.values()) {
        reporter.alias(id);
    }
}
//# sourceMappingURL=alias.js.map